import { createFormkitRenderer } from "@hightouch/formkit";
import { Liquid } from "./liquid";

export const formkitRenderer = createFormkitRenderer(new Liquid());
